<script setup>
const route = useRoute()
const isQuery = computed(() => Boolean(route.query.pid))
</script>

<template>
  <div>
    <PageRiver v-if="!isQuery" />
    <PagePoint
      v-if="isQuery"
      :pid="route.query.pid"
    />
  </div>
</template>
